




















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CabeceraModal extends Vue {
  @Prop({ required: true }) titulo: string;

  /* state */

  isLoading: boolean = false;

  /* event handlers */

  handleCerrarClick() {
    this.$emit('cerrar');
  }
}
